export const SP_CONNECT_DEFAULT = {
  title: "Seller Central Credentials Not Found",
  body: "Connect your Amazon SP-API account to manage listings, inventory, orders, and automate your selling operations from one dashboard.",
  buttonLabel: "Connect Seller Central",
  isAlmostThere: false,
};

export const SP_CONNECT_ALMOST_THERE = {
  title: "Almost there",
  actionTitle: "Connect Seller Central",
  body: "Advertising is connected. Your sales and fees live in a separate Seller Central account, so there's no P&L yet.",
  buttonLabel: "Connect Seller Central",
  isAlmostThere: true,
};

export const ADS_CONNECT_DEFAULT = {
  title: "Campaign Manager Credentials Not Found",
  body: "Connect your Amazon Advertising account to manage campaigns, track performance, and automate insights from one dashboard.",
  buttonLabel: "Connect Advertising Account",
  isAlmostThere: false,
};

export const ADS_CONNECT_ALMOST_THERE = {
  title: "Almost there",
  actionTitle: "Connect Advertising Account",
  body: "Seller Central is connected. But ad spend runs through a separate Advertising account, so your P&L isn't complete yet.",
  buttonLabel: "Connect Advertising Account",
  isAlmostThere: true,
};

/**
 * @param {number} spCount
 * @param {number} adsCount
 * @returns {'needs_both' | 'needs_ads' | 'needs_sp' | 'complete'}
 */
export function getCredentialStatus(spCount, adsCount) {
  const hasSp = spCount > 0;
  const hasAds = adsCount > 0;
  if (!hasSp && !hasAds) return "needs_both";
  if (hasSp && !hasAds) return "needs_ads";
  if (!hasSp && hasAds) return "needs_sp";
  return "complete";
}

export function getSpModalConnectPrompt(credentialStatus) {
  if (credentialStatus === "needs_sp") return SP_CONNECT_ALMOST_THERE;
  return SP_CONNECT_DEFAULT;
}

export function getAdsModalConnectPrompt(credentialStatus) {
  if (credentialStatus === "needs_ads") return ADS_CONNECT_ALMOST_THERE;
  return ADS_CONNECT_DEFAULT;
}
